import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendListModel } from 'src/app/models/common/list.model';
import { ServiceMasterModel } from 'src/app/models/common/service-master.model';
import { RejectionReasonModel } from 'src/app/models/common/myteam-model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { USER_ROLE_TYPE_EXTERNAL, UserRole } from 'src/app/models/common/user-role';
import { UserMasterApiService } from 'src/app/services/domain_code/user-master-api.service';
import { MyTeamService } from '../../my-account/my-team/my-team.service';
import { DomainCodeApiService } from 'src/app/services/domain_code/domain-code-api.service';
import { DomainCode } from 'src/app/models/common/model';
import { RequirementsModel, RequirementError } from 'src/app/pages/one-way-data/request/requirements-model';
import { VerifyCustomerService } from '../verify-customer.service';
import { BehaviorSubject } from 'rxjs';
import { ServiceMappingApiService } from 'src/app/services/domain_code/service-mapping-api.service';
import { InviteModel } from './lead-create';
import { CompanyApiService } from 'src/app/services/domain_code/company-api.service';
import { environment } from 'src/environments/environment';
import { LocationModel } from 'src/app/models/container_master_model/location';
import { AuthService } from 'src/app/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { WarningBoxComponent } from '../../dialog-box/warning-box/warning-box.component';
@Component({
  selector: 'logzy-lead-create',
  templateUrl: './lead-create.component.html',
  styleUrls: ['./lead-create.component.scss', '../user-verification/user-verification.component.scss']
})
export class LeadCreateComponent implements OnInit {
  @Output()
  newCompanyData = new EventEmitter();
  @Input()
  getAddedCompany = new BehaviorSubject(null);

  @Output()
  companyAdded = new EventEmitter();


  isEditable: boolean = true;
  requestTypeList: BackendListModel<ServiceMasterModel>;
  rejectionReasonList: BackendListModel<RejectionReasonModel>;
  profileRoleList: BackendListModel<UserRole>;
  superLocationSourceLabel: string;
  superLocationDestinationLabel: string;
  // leadObj: LeadCreateModel;
  inviteObj: InviteModel;
  containerConditionList: BackendListModel<DomainCode>;
  transactionTypeList: BackendListModel<DomainCode>;

  country_url: string = `${ApiRoutes.Geo}country/?name=::search::`;
  state_url: string = `${ApiRoutes.Geo}state/?name=::search::`;
  port_url = `${ApiRoutes.Location}?location_type_name=port&search=::search::`;
  // port_url = `${ApiRoutes.DepotMaster}super_location/?search=::search::&type=region,country,port`;
  role_url = `${ApiRoutes.Company}profile_role/?type=${USER_ROLE_TYPE_EXTERNAL}&search=::search::`;
  company_url = `${ApiRoutes.Company}company/?search=::search::`;
  container_size_type_url = `${ApiRoutes.ContainerMaster}container_size_type/?search=::search::`
  transaction_type_url = `${ApiRoutes.DomainCode}?group=LeadRequestTransactionTypes_`
  transaction_type_urls;
  resourceOptions: any;
  canvas: string = "Canvas";
  open1: string = "sidepanel";
  bindCompany = new BehaviorSubject(null)
  bindNewCompany = new BehaviorSubject(null)
  errorObj: any = {};
  uerResponse: any;
  isFormSubmitted = false;
  baseApiUrl = environment.baseApiUrl;
  isCustomer: boolean;

  constructor(private route: ActivatedRoute,
    private verifyCustomerService: VerifyCustomerService,
    private myTeamService: MyTeamService,
    private snackBar: MatSnackBar,
    private userService: UserMasterApiService,
    private domainService: DomainCodeApiService,
    private router: Router,
    private mappingService: ServiceMappingApiService,
    private companyService: CompanyApiService,
    private authService: AuthService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.resetComponent();
    this.getResourceSourceOptions();
    this.getRequestTypeList();
    this.getExternalInviteLeadOptions();
    // this.getAddedCompany.subscribe(item => {
    //   if (item != null) {
    //     this.leadObj.invite.company = item;
    //   }
    // });
  }
  closeDetails() {
    this.router.navigateByUrl(`verify-customer`);
  }
  resetComponent() {
    this.isCustomer = this.authService.isCustomer();

    this.inviteObj = new InviteModel();
    // this.inviteObj.lead.requirements.push(new RequirementsModel());
    console.log("Invite Object", this.inviteObj)
    this.getRejectionReasonList();
    this.getProfileRoleList();
    this.getContainerCondition();
  }

  setTransactionType(transaction_type) {
    for (let i = 0; i < this.transactionTypeList.results.length; i++) {
      if (transaction_type == this.transactionTypeList.results[i].dev_value) {
        this.inviteObj.lead.transaction_type = this.transactionTypeList.results[i]
      }
    }
  }

  // setRole() {
  //   for (let i = 0; i < this.profileRoleList.results.length; i++) {
  //     if (this.profileRoleList.results[i].name == 'Admin') {
  //       this.leadObj.invite.role = this.profileRoleList?.results[i];
  //     }
  //   }
  // }

  getRejectionReasonList() {
    this.myTeamService.getRejectionReason().subscribe({
      next: response => {
        this.rejectionReasonList = response;
      },
      error: error => {
        console.log(error)
        return error;
      }
    });
  }

  getProfileRoleList() {
    this.userService.getRoleByType(USER_ROLE_TYPE_EXTERNAL).subscribe({
      next: response => {
        this.profileRoleList = response;
      },
      error: error => {
        console.log(error)
        return error;
      }
    });
  }

  getTransactionTypes(request_type, transaction_type) {
    this.domainService.getByGroup(request_type).subscribe({
      next: response => {
        this.transactionTypeList = response;
        this.setTransactionType(transaction_type);
      }, error: error => {
        return error;
      }
    });
  }

  getContainerCondition(grp = 'ContainerCondition') {
    this.domainService.getByGroup(grp).subscribe({
      next: response => {
        this.containerConditionList = response;
      },
      error: error => {
        return error;
      }
    });
  }

  // filterStates(country) {
  //   if (country != null) {
  //     if (country.id != this.leadObj.invite.country?.id) {
  //       this.leadObj.invite.country = country;
  //       this.leadObj.invite.state = null;
  //       this.state_url = `${ApiRoutes.Geo}state/?name=::search::&country=${country.id}`;
  //     }
  //   }
  // }

  addRequirements() {
    this.inviteObj.lead.requirements.push(new RequirementsModel());
    // this.leadObj.error.requirements.push(new RequirementError());
    console.log("this.inviteObj.lead.requirements", this.inviteObj.lead.requirements)
  }

  removeRequirements(idx) {
    if (this.isEditable) {
      this.inviteObj.lead.requirements.splice(idx, 1);
    }
  }

  country;
  state;
  address;
  getCompanyDetails(event) {
    if (event != null) {
      if (event.id != null) {
        this.inviteObj.company = event;
        this.country = event.country;
        this.state = event.state;
        this.address = event.address;
      } else {
        if (typeof event == 'object') {
          let data = {
            name: event.legal_name,
            country: event.country,
            state: event.state,
            address: event.address,
          }
          this.openEdit(data);
        }
      }
    }
  }

  // setRemarks(event) {
  //   if (event != null) {
  //     this.inviteObj.lead.lead_status = event
  //     if (event == 'approved') {
  //       return this.inviteObj.remarks = 'Approved';
  //     } else if (event == 'rejected') {
  //       return this.inviteObj.remarks = 'Rejected';
  //     } else if (event == 'pending') {
  //       return this.inviteObj.remarks = 'Pending';
  //     } else {
  //       return this.inviteObj.remarks = 'Under process';
  //     }
  //   }
  // }
  isApproveLogin:boolean = true;

  setRemarks(event) {
    if (event != null) {
      this.inviteObj.lead.lead_status = event
        // this.leadObj.remarks = event ? 'Approved' : 'Rejected';
        if (event == 'approved') {
            this.isApproveLogin = true;
            this.inviteObj.loginApprovalList = this.inviteObj.loginApprovalList_Up;
            return this.inviteObj.remarks = 'Approved';
        } else if (event == 'rejected') {
            this.isApproveLogin = true;
            this.inviteObj.loginApprovalList = this.inviteObj.loginApprovalList;
            return this.inviteObj.remarks = 'Rejected';
        } else if (event == 'pending') {
            this.isApproveLogin = true;
            this.inviteObj.loginApprovalList = this.inviteObj.loginApprovalList;
            return this.inviteObj.remarks = 'Pending';
        } else {
            this.isApproveLogin = false;
            this.inviteObj.remarks = 'Under process';
            return this.inviteObj.is_login_approved = 'under_process'
        }
    }
}

  getLocationLabel(request) {
    switch (request?.dev_name) {
      case 'one_way':
        this.superLocationSourceLabel = 'Pick-up Location(s)*';
        this.superLocationDestinationLabel = 'Drop-off Location(s)*';
        break;
      case 'buy_sell':
        if (this.inviteObj.lead.transaction_type == 'use') {
          this.superLocationSourceLabel = 'Buy Location*';
        } else if (this.inviteObj.lead.transaction_type == 'supply') {
          this.superLocationSourceLabel = 'Sell Location*';
        }
        else {
          this.superLocationSourceLabel = 'Buy Location*';
        }
        break;
      case 'lease':
        this.superLocationSourceLabel = 'On-hire Location*';
        this.superLocationDestinationLabel = 'Off-hire Location*';
        break;
    }
    this.inviteObj.lead.transaction_type = null;
    this.transaction_type_urls = this.transaction_type_url + request?.dev_name;
  }

  getTransactionType(type) {
    if (this.inviteObj?.lead.request_type?.dev_name == 'buy_sell') {
      if (type == 'use') {
        this.superLocationSourceLabel = 'Buy Location*';
      }
      else {
        this.superLocationSourceLabel = 'Sell Location*';
      }
    }
  }

  snackBarMessage() {
    this.snackBar.open("Lead Generated successfully!", 'Close', {
      verticalPosition: 'top',
      duration: 2000,
    });
  }

  setRejection(event) {
    this.inviteObj.rejection_reason = event;
    this.inviteObj.lead.rejection_reason = event;
    // if(error){
    //   this.errorObj.rejection_reason = [error];
    //   this.errorObj.lead.rejection_reason = [error];
    // }
    // else{
    //   this.errorObj.rejection_reason = [];
    // }
  }

  getResourceSourceOptions() {
    this.verifyCustomerService.getResourceSourceOptions().subscribe({
      next: res => {
        this.resourceOptions = res;
        // this.inviteObj.lead.request_source = this.resourceOptions?.actions?.POST?.request_source?.choices[0].value;
      }
    });
  }
  openEdit(data) {
    this.open1 = " sidepanel slidepanelOpen ";
    this.canvas = "Canvas setCanvas";
    setTimeout(() => {
      this.bindCompany.next(data);
    }, 500);
  }

  closeEdit() {
    this.open1 = " sidepanel ";
    this.canvas = "Canvas ";
    this.bindCompany.next(null);
  }

  bindAddedCompany(event) {
    // this.open1 = " sidepanel ";
    // this.canvas = "Canvas ";
    // this.bindNewCompany.next(event);
    if (event != null) {
      this.getCompanyById(event.id)
    }
  }
  getRequestTypeList() {
    this.mappingService.getUserServiceList().subscribe({
      next: response => {
        this.requestTypeList = response;
        this.inviteObj.lead.request_type = response.results[0];
      }
    });
  }

  //get Depot By ID
  getCompanyById(id) {
    this.companyService.getCompanyById(id).subscribe({
      next: response => {
        this.inviteObj.company = JSON.parse(JSON.stringify(response));
        return response;
      }
    });
  }


  submitLead() {
    if (this.inviteObj.is_lead_valid()) {
      this.inviteObj.lead.mobile = this.inviteObj?.phone?.as_e164;
      this.inviteObj.lead.email = this.inviteObj?.email;
      this.inviteObj.lead.remarks = this.inviteObj?.remarks;

      this.verifyCustomerService.postUser(this.inviteObj.getLeadCreatePayload()).subscribe({
        next: res => {
          this.snackBarMessage();
          setTimeout(() => {
            this.router.navigate(['/verify-customer']);
          }, 1000);
        },
        error: err => {
          if(err.error.is_login_approved){
            this.openWarning(`${err.error.is_login_approved}`, '', 'I Understand');
          }
          return this.catchError(err);
        }
      });
    }
  }

  // is_user_valid() {
  //   let leadError = true;
  //   if (this.inviteObj.lead.request_source == null) {
  //     this.errorObj.inviteObj.lead.request_source.push('Approve Login field is required')
  //   }
  //   return this.errorObj.invite.is_login_approved.length == 0 && leadError
  // }
  catchError(error) {
    if (error.status >= 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug("error object", this.errorObj);
      return error;
    } else if (error.status > 399 && error.status < 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug("error object", this.errorObj);
      return error;
    }
  }
  showAllPols(event) {
    if (event.flag) {
      this.inviteObj.lead.pol_list = event.option;
    }
  }

  polList: BackendListModel<LocationModel>;
  podList: BackendListModel<LocationModel>;


  resetPolsError(event) {
    if (this.inviteObj.lead.pol_list.length) {
      this.inviteObj.error.pol_list = [];
      return;
    }
  }

  resetPodsError(event) {
    if (this.inviteObj.lead.pod_list.length) {
      this.inviteObj.error.pod_list = [];
      return;
    }
  }
  leadOptions:any;
  leadExternalInviteOptions:any;
   //get Depot By ID
   getExternalInviteLeadOptions() {
    this.verifyCustomerService.optionsLeadExternalInvite().subscribe({
      next: response => {
        this.leadOptions = response;
       this.leadExternalInviteOptions= this.leadOptions.actions.POST.lead.children?.lead_status.choices;
       if (!this.isCustomer) {
        this.leadExternalInviteOptions = this.leadExternalInviteOptions.filter(option => (option.value !== "pending") );
        console.log("this.leadExternalInviteOptions",this.leadExternalInviteOptions)
      }
      }
    });
  }
  openWarning(label: string, description, action1: string, action2?: string) {
    const dialogRef = this.dialog.open(WarningBoxComponent, {
      panelClass: 'dialog-container-custom',
      disableClose: true,
      data: { subTitle: label, parent: this, description: description, label1: action1, label2: action2 }
    });
  }
}

